import { render, staticRenderFns } from "./orderRelated.vue?vue&type=template&id=2eb00cab"
import script from "./orderRelated.vue?vue&type=script&lang=js"
export * from "./orderRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports